module.exports = __webpack_public_path__ + "static/img/lmy_1.d1d9be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/lmy_1.jpg
// module id = /Msn
// module chunks = 15